import { useStore } from '../core/store';
import { LoadableStatus } from '../mobx-utils';
import { useEffect, useState } from 'react';

import { login } from '../pages/login';

export function useSignOnLink() {
  const store = useStore();

  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccessful, setIsSuccessful] = useState(false);

  useEffect(() => {
    async function signOn() {
      const url = new URL(window.location.href);

      const bookingId = url.searchParams?.get('bookingId');
      const token = url.searchParams?.get('token');

      if (bookingId && token) {
        setIsLoading(true);
        setError(null);
        setIsSuccessful(false);

        const { success, data, errorMessage } = await login({
          bookingId,
          token,
        });

        setIsLoading(false);

        if (success && data && !errorMessage) {
          store.BookingStore.booking.setData(data);
          store.BookingStore.booking.setStatus(LoadableStatus.done);
          setIsSuccessful(true);
        } else {
          setError(errorMessage);
        }
      }
    }
    signOn();
  }, []);

  return {
    error,
    isLoading,
    isSuccessful,
    setError,
    setIsLoading,
    setIsSuccessful,
  };
}
